class SliderProducts {
	constructor() {
		this.selectors = {
			document: document,
			slickSliderBanner: '.slickSliderWithBanner',
		};
		this.init();
		this.timeout_1 = null;
		this.timeout_2 = null;
		this.events();
	};
	init() {
		this.getNodes();
	}

	getNodes() {
		var _this = this;
		this.nodes = {};
		$.each(this.selectors, function(key, selector) {
			_this.nodes[key] = $(selector);
		});
	}

	events() {

		// Slider for News
		this.nodes.slickSliderBanner.slick({
			dots: false,
			infinite: true,
			accessibility: false,
			speed: 200,
			arrows: true,
			slidesToShow: 3,
			lazyLoad: 'ondemand',
			slidesToScroll: 3,
			autoplay: false,
			prevArrow: '<button class="slick-prev"><i class="icon-custom icon1-arrow-left-2"></i></button>',
			nextArrow: '<button class="slick-next"><i class="icon-custom icon1-arrow-right-2"></i></button>',
			responsive: [{
				breakpoint: 1199,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				}
			}, {
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 2
				}
			}, 	{
				breakpoint: 769,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
				{
				breakpoint: 576,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}]
		});

	}
}
new SliderProducts();
